<template>
  <div class="my-5 text-center">
    <!-- <template v-if="state === null"> -->
      <p>{{ $t('auth.login.processing') }}</p>
      <loading-spinner/>
    <!-- </template>
    <b-card v-else-if="state === 'REGISTER-ACCEPT-TERMS'">
      <h4 class="mb-3">{{ $t('auth.sso.terms-title') }}</h4>
      <form method="POST" @submit.prevent="confirmRegister">
        <b-form-group>
          <b-form-checkbox class="subtle-text" required v-model="form.termsAccepted">
            <i18n path="auth.register.agree-to-terms">
              <template v-slot:termsConditionsLink>
                <a href="/static/documents/Real+Links+Terms+%26+Conditions.pdf" tabindex="-1" target="_blank">
                  {{ $t('general.terms-conditions') }}
                </a>
              </template>
              <template v-slot:privacyPolicyLink>
                <a href="https://www.reallinks.io/privacy-policy/" tabindex="-1" target="_blank">
                  {{ $t('general.privacy-policy') }}
                </a>
              </template>
            </i18n>
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <b-btn class="px-5" :disabled="form._isSubmitting" size="md" type="submit" variant="primary">
            <template v-if="form._isSubmitting">{{ $t('ctas.continuing') }}</template>
            <template v-else>{{ $t('ctas.continue') }}</template>
          </b-btn>
        </b-form-group>
      </form>
    </b-card> -->
  </div>
</template>

<script>
import ls from 'local-storage';
import AuthLoginByIdentityMutation from '@src/graphql/mutations/AuthLoginByIdentity.gql';
import AuthSignupByIdentityMutation from '@src/graphql/mutations/AuthSignupByIdentity.gql';
import authMixin from '@src/mixins/auth';
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import qs from 'querystring';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    company: Object,
  },
  components: {
    LoadingSpinner,
  },
  mixins: [ authMixin ],
  data: () => ({
    err: null,
    state: null,
    form: {},
  }),
  metaInfo() {
    return {
      title: this.$t('auth.login.processing'),
    };
  },
  computed: {
    ...mapRoot([ 'isProd', 'isLoggedIn', 'user' ]),
    windowHash() {
      const { hash: hashString } = this.$route;
      return hashString ? qs.parse(hashString.substring(1)) : null;
    },
    accessToken() {
      const { access_token: accessToken } = this.windowHash || {};
      return accessToken;
    }
  },
  async mounted() {
    try {
      const { name } = this.$route;
      if (name === 'LoginSSO') {
        await this.confirmLogin();
      } else if (name === 'LoginAdmin') {
        await this.confirmAdminSignOn();
      } else {
        window.location = '/';
      }
    } catch (err) {
      this.$log.error(err);
      this.$notifyFatalErr(err);
    }
  },
  methods: {
    async confirmLogin() {
      this.$assert(this.accessToken, new Error('Missing access token from Cognito callback'));

      if (this.windowHash && this.windowHash.state) {
        const { next, redirect } = qs.parse(this.windowHash.state);
        if (next || redirect) {
          this.$router.replace({ ...this.$route, query: { next, redirect } });
        }
      }

      try {
        // Attempt to login by identity
        const { errors } = await this.$apollo.mutate({
          mutation: AuthLoginByIdentityMutation,
          variables: { accessToken: this.accessToken },
          update: (client, { data: { loginByIdentity } }) => this.updateAuthResponse(client, loginByIdentity),
          errorPolicy: 'all',
        });

        if (Array.isArray(errors)) {
          errors.forEach(err => this.$log.error('LoginByIdentity', err));
          throw errors.shift();
        }

        this.$assert(this.isLoggedIn, new Error('Failed to login by identity'));
        await this.afterAuthenticated(this.nextRoute);
      } catch (err) {
        // If we get back a USER_NOT_FOUND error
        this.$assert(err && err.extensions && err.extensions.code === 'USER_NOT_FOUND', err);
        // this.state = 'REGISTER-ACCEPT-TERMS';
        this.confirmRegister();
      }
    },
    async confirmRegister() {
      this.$assert(this.accessToken, new Error('Missing access token from Cognito callback'));
      // this.$assert(this.form && this.form.termsAccepted, new Error('Terms not accepted'));
      this.form._isSubmitting = true;

      // Attempt to register by identity
      const referrerUserID = ls('referrerUserID');

      const { errors } = await this.$apollo.mutate({
        mutation: AuthSignupByIdentityMutation,
        variables: {
          accessToken: this.accessToken,
          signup: {
            locale: this.$i18n.locale,
            referrerUser: referrerUserID ? { id: referrerUserID } : null,
          },
        },
        update: (client, { data: { signupByIdentity } }) => this.updateAuthResponse(client, signupByIdentity),
        errorPolicy: 'all',
      });

      if (Array.isArray(errors)) {
        errors.forEach(err => this.$log.error('SignupByIdentity', err));
        this.form._isSubmitting = false;
        throw errors.shift();
      }

      this.$assert(this.isLoggedIn, new Error('Failed to signup by identity'));

      if (referrerUserID) {
        ls.remove('referrerUserID');
      }

      this.state = null;
      await this.afterSignup(this.nextRoute);
    },
    async confirmAdminSignOn() {
      try {
        // In case the Admin was already logged-in, clear it!
        this.clearAuth();

        const { isProd } = this;
        const { referrer } = document;

        const validReferrers = isProd
          ? [ 'https://admin.reallinks.io/' ]
          : [ 'https://admin.reallinks.dev/', 'http://localhost:8080/' ];
        this.$assert(validReferrers.includes(referrer), 'Expected admin referrer', { referrer });

        const { hash: hashString } = this.$route;
        const windowHash = qs.parse((hashString || '').substring(1));
        this.$log.debug(windowHash);

        const { token: adminToken } = windowHash || {};
        this.$assert(adminToken, new Error('Missing admin token'));
        ls.set('token', adminToken);

        await this.resumeSession();
        this.$assert(this.isLoggedIn, new Error('Failed to login by admin'));
        await this.afterAuthenticated({ name: 'Dashboard' });
      } catch (err) {
        this.$log.error(err);
        // Clear the session data
        this.clearAuth();
        // And push to the login page
        this.$router.replace({ name: 'Login' });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Auth/SSO.vue